import { render, staticRenderFns } from "./adgroup-display-type-chip.vue?vue&type=template&id=cce20338&scoped=true&"
import script from "./adgroup-display-type-chip.vue?vue&type=script&lang=js&"
export * from "./adgroup-display-type-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce20338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
